import { cookie } from '@pmi/pmi-iqos-shared-react'

export default class IqosphereLottery {
  constructor(api) {
    this.api = api
  }

  confirm = async prizeId => {
    const res = await this.api.post(
      '/iqosphere/prizelotteryexchange/confirm?rpc=true',
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        useProxy: true,
        withCredentials: true,
        mock: this.api.getMock('confirmLottery'),
        data: {
          prizeId
        }
      }
    )
    return res
  }

  getExchangeStock = async prizeId => {
    const res = await this.api.get(
      '/iqosphere/prizelotteryexchange/stockexchange?rpc=true&prizeId=' +
        prizeId,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        useProxy: true,
        withCredentials: true,
        mock: this.api.getMock('getExchangeStock')
      }
    )
    return res
  }

  confirmAddress = async data => {
    const res = await this.api.post(
      '/iqosphere/prizelotteryexchange/confirmaddress',
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('confirmAddress'),
        data
      }
    )
    return res
  }

  reserveDigitalPrize = async prizeCode => {
    const res = await this.api.post('/iqosphere/prizes/digital/reserve', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data: {
        prizeCode
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('reserveDigitalPrize')
    })
    return res
  }
}
